const styles = `/* TODO: We need to disable the stylelint until we don't have the correct figma tokens for the arrows */
/* stylelint-disable function-disallowed-list */
:host([position^=top-]) {
  --ARROW-OFFSET-Y: calc(var(--content-height) - 9px);
  --ARROW-ROTATION: 45deg;
  --ARROW-SHADOW: rgba(0, 0, 0, 0.12) 4px 4px 4px -2px, rgba(0, 0, 0, 0.08) 2px 2px 2px 0;
}

:host([position^=bottom-]) {
  --ARROW-OFFSET-Y: -7px;
  --ARROW-ROTATION: calc(-45deg - 90deg);
  --ARROW-SHADOW: rgba(0, 0, 0, 0.04) 1px 1px 2px 0;
}

:host([position^=right-]) {
  --ARROW-ROTATION: calc(45deg + 90deg);
  --ARROW-OFFSET-X: -7px;
  --ARROW-SHADOW: rgba(0, 0, 0, 0.12) 2px 2px 2px 0;
}

:host([position^=left-]) {
  --ARROW-ROTATION: calc(45deg + 90deg + 180deg);
  --ARROW-OFFSET-X: calc(var(--content-width) - 10px);
  --ARROW-SHADOW: rgba(0, 0, 0, 0.12) 2px 2px 2px 0;
}

:host([position=top-start]),
:host([position=bottom-start]) {
  --ARROW-OFFSET-X: calc(var(--trigger-width) / 2 - var(--ARROW-SIZE) / 2 - var(--ARROW-BORDER));
}

:host([position=top-center]),
:host([position=bottom-center]) {
  --ARROW-OFFSET-X: calc(var(--content-width) / 2 - var(--ARROW-SIZE) / 2);
}

:host([position=top-end]),
:host([position=bottom-end]) {
  --ARROW-OFFSET-X: calc(
    var(--content-width) - var(--POPOVER-OFFSET) - var(--trigger-width) / 2 + var(--ARROW-SIZE) / 2 + var(--ARROW-BORDER)
  );
}

:host([position=right-start]),
:host([position=left-start]) {
  --ARROW-OFFSET-Y: calc(
    var(--trigger-height) / 2 - ((var(--ARROW-SIZE) / 2 - var(--ARROW-BORDER) / 2) + var(--ARROW-POSITION-FIX))
  );
}

:host([position=right-center]),
:host([position=left-center]) {
  --ARROW-OFFSET-Y: calc(var(--content-height) / 2 - var(--ARROW-SIZE) / 2);
}

:host([position=right-end]),
:host([position=left-end]) {
  --ARROW-OFFSET-Y: calc(
    var(--content-height) - var(--POPOVER-OFFSET) - var(--trigger-height) / 2 + (var(--ARROW-SIZE) / 2 + var(--ARROW-BORDER)) + var(--ARROW-POSITION-FIX)
  );
}

:host(:is([position=right-end], [position=right-start])[single-line]),
:host(:is([position=left-end], [position=left-start])[single-line]) {
  --ARROW-OFFSET-Y: calc(var(--content-height) / 2 - var(--ARROW-SIZE) / 2);
  --POPOVER-Y: calc(var(--trigger-y) - (var(--content-height) / 2 - var(--trigger-height) / 2));
}

:host {
  --POPOVER-OFFSET: var(--goto-spacing-05);
  --POPOVER-HALF-OF-OFFSET: calc(var(--goto-spacing-05) / 2);
  --POPOVER-HEIGHT: min-content;
  --POPOVER-MARGIN: 8px;
  --POPOVER_TRANSFORMATION: translate(var(--POPOVER-X), var(--POPOVER-Y));
  --POPOVER-BORDER: 1px;
  --ARROW-BORDER: 2px;
  --ARROW-SIZE: 14px;
  --ARROW-POSITION-FIX: 0px;
  word-break: break-word;
  max-width: var(--max-width);
  width: fit-content;
  min-height: var(--POPOVER-HEIGHT);
  height: auto;
  max-height: fit-content;
  padding: var(--goto-spacing-04);
  z-index: var(--z-index);
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  border-radius: var(--goto-radius-medium);
  background-color: var(--goto-surface-color-default);
  border-color: var(--goto-border-color-secondary);
  box-shadow: var(--goto-elevation-xlarge);
  padding: var(--goto-spacing-04);
  color: var(--goto-type-color-default);
  opacity: 1;
  visibility: visible;
  font-family: var(--body-font);
  font-size: var(--type-ramp-base-font-size);
  line-height: var(--type-ramp-base-line-height);
  transform: translate(var(--trigger-x), var(--trigger-y));
  box-shadow: var(--goto-elevation-medium);
  display: block;
  left: 0;
  position: absolute;
  top: 0;
}
:host ::slotted(*) {
  background-color: inherit;
  word-break: break-word;
}

:host([large]) {
  padding: var(--goto-spacing-06);
}

:host([custom-width]) {
  width: var(--content-width);
}

:host([menu]) {
  padding: var(--goto-spacing-00);
  width: var(--content-width);
}

:host([menu][position^=right-]) {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

:host([menu][position^=left-]) {
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

:host([menu][position=right-start]),
:host([menu][position=right-end]),
:host([menu][position=left-start]),
:host([menu][position=left-end]) {
  --ARROW-POSITION-FIX: var(--ARROW-SIZE) / 2 + var(--ARROW-BORDER);
}

:host([compact]) {
  padding: var(--goto-spacing-02);
  font: var(--goto-tooltip-font);
  padding: var(--goto-spacing-01) var(--goto-spacing-02);
  min-height: auto;
}

:host([inverted]) {
  background-color: var(--goto-surface-color-inverted);
  border-color: var(--goto-border-color-inverted);
  color: var(--goto-type-color-inverted);
  border-color: var(--goto-border-color-inverted);
}

:host([arrow]) {
  --POPOVER-MARGIN: calc(var(--goto-spacing-02) + var(--goto-spacing-01));
}
:host([arrow])::after {
  box-sizing: border-box;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(var(--ARROW-OFFSET-X), calc(var(--ARROW-OFFSET-Y) - 1px)) rotate(var(--ARROW-ROTATION));
  width: var(--ARROW-SIZE);
  aspect-ratio: 1;
  border-bottom-right-radius: var(--goto-radius-small);
  border-right: inherit;
  border-bottom: inherit;
  background-color: inherit;
  box-shadow: var(--ARROW-SHADOW);
  z-index: -1;
}

:host([inactive]) {
  visibility: hidden;
  display: none;
}`; export default styles;